import Script from "next/script";
import { createTracker } from "..";
import { criteoEvent } from "../../../types";

/**
 * トップページトラッカー
 */

interface ViewHomeTrackerProps {
  email?: string;
}

export const ViewHomeTracker = ({ email }: ViewHomeTrackerProps) => {
  const tracker = createTracker(email);
  tracker.push({ event: criteoEvent.viewHome });
  return (
    <Script
      id="NextScript/Criteo_viewHome"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          window.criteo_q = window.criteo_q || [];
          window.criteo_q.push(${JSON.stringify(tracker)});
        `,
      }}
    />
  );
};
